<template>
  <v-card flat>
    <contract-upgrade-calculator v-if="false" :preisKombiAbo="690" vertragsEndDatum="2024-12-06"></contract-upgrade-calculator>
    <employee-list v-if="false"></employee-list>
    <album-manager v-if="true"></album-manager>
  </v-card>
</template>

<script>
import contractUpgradeCalculator from "@/views/dashboard/contract/utils/contractUpgradeCalculator"
import employeeList from "@/views/dashboard/employee/employeeList"
import albumManager from "@/views/google/display/albumManager"

export default {
  components: {
    contractUpgradeCalculator,
    employeeList,
    albumManager,
  },
  data() {
    return {}
  },
  async created() {},
  methods: {},
}
</script>
